<p>{{ message | async }}</p>